import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  AbstractControl,
  ControlContainer,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';

@Component({
    selector: 'pr-select-form',
    templateUrl: './pr-select-form.component.html',
    styleUrls: ['./pr-select-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrSelectFormComponent,
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: PrSelectFormComponent,
        },
    ],
    standalone: false
})
export class PrSelectFormComponent implements OnInit, ControlValueAccessor {
  @Input() formControlName: string;
  @Input() derrors: string;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() searchPlaceholder: string;
  @Input() options: any[];
  @Input() value: any;
  @Output() onChange?: EventEmitter<any> = new EventEmitter<any>();

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    if (this.formControlName && this.controlContainer) {
      return this.controlContainer.control.get(this.formControlName);
    }
    return null;
  }

  get currentValue() {
    return this.control ? this.control.value : this.value;
  }

  ngOnInit() {}

  onInputChange(option) {
    this.onChange?.emit(option);
    if (this.control) {
      this.control.setValue(option);
    }
  }

  writeValue(value: any): void {}

  registerOnChange(onChange: any): void {}

  registerOnTouched(onTouched: any): void {}

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
